import { Link } from 'react-router-dom'
import LogisticsCoursePro from './LogisticsCoursePro'
import EnglishCoursePro from './EnglishCoursePro'
import LeadershipCoursePro from './LeadershipCoursePro'
import './AdminDashboard.css'
import './AdminDashboard.sales.css'
import { DEPARTMENTS, PROJECT_RUBRICS, PROJECT_STATUSES, EMPTY_WORKER, EMPTY_TRAINING, EMPTY_EQUIP, EMPTY_PROJECT, EMPTY_SALE } from './admin/constants'
import {
  renderOverview, renderWorkers, renderProjects, renderSell, renderTraining,
  renderEquipment, renderItSupport, renderChat, renderTracking, renderVisitors,
  renderSchedule, renderPolicy, renderSafety, renderCareers,
} from './admin'
import { useAdminDashboard } from './AdminDashboard.logic'

const LANG_KEY = 'dashboard_lang'

function AdminDashboard(props) {
  const {
    accessLogs,
    activeCourse,
    activeProject,
    activeTab,
    activeWorkersList,
    adminCommentText,
    adminNotifications,
    adminReply,
    adminTimeOffRequests,
    allProgress,
    assignModal,
    assignSelected,
    assignments,
    authError,
    careersMsgMap,
    chatActiveSession,
    chatEndRef,
    chatMsgPollRef,
    chatPollRef,
    chatSessionMsgs,
    chatSessions,
    dismissAdminNotif,
    editForm,
    editWorker,
    editingJobId,
    equipmentForm,
    equipmentStatus,
    existingSlugs,
    previewUrls,
    fetchMsgs,
    fetchSessions,
    filteredSales,
    filteredWorkers,
    handleAddProject,
    handleAddSale,
    handleAddTraining,
    handleAddWorker,
    handleAdminComment,
    handleAssignCourse,
    handleDeleteProject,
    handleDeleteSale,
    handleDeleteSaleAndClose,
    handleDeleteTraining,
    handleDeleteWorker,
    handleEquipmentDelete,
    handleEquipmentSubmit,
    handleItReply,
    handleLogin,
    handleLogout,
    handleProjectStatusChange,
    handleSaleStatusChange,
    handleSaveSaleDetail,
    handleSaveWorker,
    handleSelectChatSession,
    handleSendReply,
    handleTimeOffAction,
    handleUnassignCourse,
    handler,
    isAuthenticated,
    itActiveWorker,
    itConversations,
    itEndRef,
    itMessages,
    itReply,
    items,
    jobApplications,
    jobForm,
    jobListings,
    lang,
    navigate,
    notifOpen,
    notifRef,
    onAdd,
    openEditWorker,
    password,
    adminEmail,
    setAdminEmail,
    authChecking,
    selectedApplication,
    setSelectedApplication,
    projectForm,
    projectStatus,
    projects,
    saleForm,
    saleSearch,
    saleStatus,
    sales,
    selectedSale,
    setAccessLogs,
    setActiveCourse,
    setActiveProject,
    setActiveTab,
    setAdminCommentText,
    setAdminNotifications,
    setAdminReply,
    setAdminTimeOffRequests,
    setAllProgress,
    setAssignModal,
    setAssignSelected,
    setAssignments,
    setAuthError,
    setCareersMsgMap,
    setChatActiveSession,
    setChatSessionMsgs,
    setChatSessions,
    setEditForm,
    setEditWorker,
    setEditingJobId,
    setEquipmentForm,
    setEquipmentStatus,
    setIsAuthenticated,
    setItActiveWorker,
    setItConversations,
    setItMessages,
    setItReply,
    setJobApplications,
    setJobForm,
    setJobListings,
    setLang,
    setNotifOpen,
    setPassword,
    setProjectForm,
    setProjectStatus,
    setProjects,
    setSaleForm,
    setSaleSearch,
    setSaleStatus,
    setSales,
    setSelectedSale,
    setShowJobForm,
    setSidebarOpen,
    setTimeOffActionMsg,
    setTrackingFilter,
    setTraining,
    setTrainingForm,
    setTrainingStatus,
    setUploadedItems,
    setVisitorLogs,
    setWorkerForm,
    setWorkerSearch,
    setWorkerStatus,
    setWorkers,
    showJobForm,
    sidebarOpen,
    t,
    timeOffActionMsg,
    toggleAssignWorker,
    toggleChatAccess,
    toggleWorkerStatus,
    trackingFilter,
    training,
    trainingForm,
    trainingStatus,
    unreadCount,
    uploadedItems,
    visitorLogs,
    workerForm,
    workerSearch,
    workerStatus,
    workers,
  } = useAdminDashboard(props)

  // ─── Active course view ─────────────────────────────────────────
  if (activeCourse) {
    if (activeCourse.id === 'english-1000h') {
      return <EnglishCoursePro workerId="admin-preview" courseId={activeCourse.id} onBack={() => setActiveCourse(null)} />
    }
    if (activeCourse.id === 'leadership-16') {
      return <LeadershipCoursePro workerId="admin-preview" courseId={activeCourse.id} onBack={() => setActiveCourse(null)} />
    }
    return (
      <LogisticsCoursePro
        workerId="admin-preview"
        courseId={activeCourse.id}
        onBack={() => setActiveCourse(null)}
      />
    )
  }

  // ─── Login ──────────────────────────────────────────────────────
  if (authChecking) {
    return (
      <div className="dash-login-screen">
        <div className="dash-login-card">
          <p style={{ textAlign: 'center', color: '#6b7280' }}>{lang === 'fr' ? 'Vérification de la session…' : 'Checking session…'}</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return (
      <div className="dash-login-screen">
        <div className="dash-login-card">
          <div className="dash-login-logo">
            <span className="dash-login-icon">🏢</span>
            <h1>{t.groupeOuambo}</h1>
            <p>{t.adminDashboard}</p>
          </div>
          <div className="dash-lang-toggle" style={{ marginBottom: '-4px' }}>
            <button type="button" className={lang === 'fr' ? 'active' : ''} onClick={() => { const n = 'fr'; localStorage.setItem(LANG_KEY, n); setLang(n) }}>FR</button>
            <button type="button" className={lang === 'en' ? 'active' : ''} onClick={() => { const n = 'en'; localStorage.setItem(LANG_KEY, n); setLang(n) }}>EN</button>
          </div>
          <form className="dash-login-form" onSubmit={handleLogin}>
            <label>{lang === 'fr' ? 'E-mail' : 'Email'}<input type="email" value={adminEmail} onChange={e => setAdminEmail(e.target.value)} placeholder="admin@example.com" autoFocus required autoComplete="username" /></label>
            <label>{t.password}<input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder={t.enterAdminPassword} required autoComplete="current-password" /></label>
            {authError && <p className="dash-login-error">{authError}</p>}
            <button className="dash-login-btn" type="submit">{t.login}</button>
          </form>
          <Link className="dash-login-back" to="/">{t.backToWebsite}</Link>
        </div>
      </div>
    )
  }

  const activeWorkers = workers.filter(w => w.status === 'active').length
  const activeProjects = projects.filter(p => p.status === 'active').length
  const totalSales = sales.reduce((s, sale) => s + (parseFloat(sale.amount.replace(/[^0-9.-]/g, '')) || 0), 0)

  const quoteCount = sales.filter(s => s.status === 'quote' || s.status === 'accepted' || s.status === 'pending').length
  const invoiceCount = sales.filter(s => ['invoice', 'confirmed', 'delivered', 'paid'].includes(s.status)).length

  const navItems = [
    { key: 'overview',    icon: '📊', label: t.overview },
    { key: 'workers',     icon: '👥', label: t.workers,    badge: workers.length || null },
    { key: 'projects',    icon: '📋', label: t.projects,   badge: activeProjects || null },
    { key: 'quotes',      icon: '📝', label: t.quotes,     badge: quoteCount || null },
    { key: 'invoices',    icon: '🧾', label: t.invoices || (lang === 'fr' ? 'Factures' : 'Invoices'), badge: invoiceCount || null },
    { key: 'sell',        icon: '💼', label: t.sell,       badge: sales.length || null },
    { key: 'training',    icon: '🎓', label: t.training,   badge: training.length || null },
    { key: 'equipment',   icon: '📦', label: t.equipment,  badge: uploadedItems.length || null },
    // Temporarily disabled — chat backend endpoint unstable
    // { key: 'chat',        icon: '💬', label: t.liveChat,   badge: unreadCount || null },
    { key: 'it-support',  icon: '🛠️', label: 'IT Support', badge: itConversations.reduce((n, c) => n + c.messages.filter(m => m.sender === 'worker').length, 0) || null },
    { key: 'tracking',  icon: '📍', label: t.tracking,  badge: null },
    { key: 'visitors',  icon: '🌐', label: lang === 'fr' ? 'Visiteurs' : 'Visitors', badge: null },
    { key: 'schedule',  icon: '📅', label: t.schedule,  badge: adminTimeOffRequests.filter(r => r.status === 'pending').length || null },
    { key: 'policy',    icon: '📜', label: t.policy,    badge: null },
    { key: 'safety',    icon: '🛡️', label: t.safety,    badge: null },
    { key: 'careers',   icon: '💼', label: lang === 'fr' ? 'Carrières' : 'Careers', badge: jobApplications.filter(a => a.status === 'pending').length || null },
  ]

  const ctx = {
    DEPARTMENTS,
    PROJECT_RUBRICS,
    PROJECT_STATUSES,
    EMPTY_WORKER,
    EMPTY_TRAINING,
    EMPTY_EQUIP,
    EMPTY_PROJECT,
    EMPTY_SALE,
    activeWorkers,
    activeProjects,
    totalSales,
    navItems,
    accessLogs,
    activeCourse,
    activeProject,
    activeTab,
    activeWorkersList,
    adminCommentText,
    adminNotifications,
    adminReply,
    adminTimeOffRequests,
    allProgress,
    assignModal,
    assignSelected,
    assignments,
    authError,
    careersMsgMap,
    chatActiveSession,
    chatEndRef,
    chatMsgPollRef,
    chatPollRef,
    chatSessionMsgs,
    chatSessions,
    dismissAdminNotif,
    editForm,
    editWorker,
    editingJobId,
    equipmentForm,
    equipmentStatus,
    existingSlugs,
    previewUrls,
    fetchMsgs,
    fetchSessions,
    filteredSales,
    filteredWorkers,
    handleAddProject,
    handleAddSale,
    handleAddTraining,
    handleAddWorker,
    handleAdminComment,
    handleAssignCourse,
    handleDeleteProject,
    handleDeleteSale,
    handleDeleteSaleAndClose,
    handleDeleteTraining,
    handleDeleteWorker,
    handleEquipmentDelete,
    handleEquipmentSubmit,
    handleItReply,
    handleLogin,
    handleLogout,
    handleProjectStatusChange,
    handleSaleStatusChange,
    handleSaveSaleDetail,
    handleSaveWorker,
    handleSelectChatSession,
    handleSendReply,
    handleTimeOffAction,
    handleUnassignCourse,
    handler,
    isAuthenticated,
    itActiveWorker,
    itConversations,
    itEndRef,
    itMessages,
    itReply,
    items,
    jobApplications,
    jobForm,
    jobListings,
    lang,
    navigate,
    notifOpen,
    notifRef,
    onAdd,
    openEditWorker,
    password,
    adminEmail,
    setAdminEmail,
    authChecking,
    selectedApplication,
    setSelectedApplication,
    projectForm,
    projectStatus,
    projects,
    saleForm,
    saleSearch,
    saleStatus,
    sales,
    selectedSale,
    setAccessLogs,
    setActiveCourse,
    setActiveProject,
    setActiveTab,
    setAdminCommentText,
    setAdminNotifications,
    setAdminReply,
    setAdminTimeOffRequests,
    setAllProgress,
    setAssignModal,
    setAssignSelected,
    setAssignments,
    setAuthError,
    setCareersMsgMap,
    setChatActiveSession,
    setChatSessionMsgs,
    setChatSessions,
    setEditForm,
    setEditWorker,
    setEditingJobId,
    setEquipmentForm,
    setEquipmentStatus,
    setIsAuthenticated,
    setItActiveWorker,
    setItConversations,
    setItMessages,
    setItReply,
    setJobApplications,
    setJobForm,
    setJobListings,
    setLang,
    setNotifOpen,
    setPassword,
    setProjectForm,
    setProjectStatus,
    setProjects,
    setSaleForm,
    setSaleSearch,
    setSaleStatus,
    setSales,
    setSelectedSale,
    setShowJobForm,
    setSidebarOpen,
    setTimeOffActionMsg,
    setTrackingFilter,
    setTraining,
    setTrainingForm,
    setTrainingStatus,
    setUploadedItems,
    setVisitorLogs,
    setWorkerForm,
    setWorkerSearch,
    setWorkerStatus,
    setWorkers,
    showJobForm,
    sidebarOpen,
    t,
    timeOffActionMsg,
    toggleAssignWorker,
    toggleChatAccess,
    toggleWorkerStatus,
    trackingFilter,
    training,
    trainingForm,
    trainingStatus,
    unreadCount,
    uploadedItems,
    visitorLogs,
    workerForm,
    workerSearch,
    workerStatus,
    workers
  }

  return (
    <div className="dash-layout">
      {sidebarOpen && <div className="dash-overlay" onClick={() => setSidebarOpen(false)} />}

      {/* Sidebar */}
      <aside className={`dash-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="dash-sidebar-brand">
          <span className="dash-brand-icon">🏢</span>
          <div><span className="dash-brand-name">G.O Admin</span><span className="dash-brand-sub">Dashboard</span></div>
          <button className="dash-sidebar-close" onClick={() => setSidebarOpen(false)}>×</button>
        </div>
        <nav className="dash-nav">
          {navItems.map(item => (
            <button key={item.key} className={`dash-nav-item ${activeTab === item.key ? 'active' : ''}`} onClick={() => navigate(item.key)}>
              <span className="dash-nav-icon">{item.icon}</span>
              <span className="dash-nav-label">{item.label}</span>
              {item.badge ? <span className="dash-nav-badge">{item.badge}</span> : null}
            </button>
          ))}
        </nav>
        <div className="dash-sidebar-footer">
          <Link className="dash-sidebar-link" to="/worker">{t.workerDashboard}</Link>
          <Link className="dash-sidebar-link" to="/logistics">{t.logisticsDashboard}</Link>
          <Link className="dash-sidebar-link" to="/">{t.publicSite}</Link>
          <button className="dash-logout-btn" onClick={handleLogout}>{t.logout}</button>
        </div>
      </aside>

      {/* Main */}
      <div className="dash-main">
        <header className="dash-topbar">
          <button className="dash-menu-btn" onClick={() => setSidebarOpen(true)}>☰</button>
          <div className="dash-topbar-title">{navItems.find(n => n.key === activeTab)?.icon} {navItems.find(n => n.key === activeTab)?.label}</div>
          <div className="dash-topbar-actions">
            <span className="dash-topbar-user">{t.admin}</span>
            <div className="dash-lang-toggle">
              <button className={lang === 'fr' ? 'active' : ''} onClick={() => setLang(l => { const n = l === 'fr' ? 'en' : 'fr'; localStorage.setItem(LANG_KEY, n); return n })}>FR</button>
              <button className={lang === 'en' ? 'active' : ''} onClick={() => setLang(l => { const n = l === 'en' ? 'fr' : 'en'; localStorage.setItem(LANG_KEY, n); return n })}>EN</button>
            </div>
            {/* Notification bell */}
            <div className="notif-wrap" ref={notifRef}>
              <button className="notif-bell-btn" onClick={() => setNotifOpen(o => !o)}>
                🔔
                {adminNotifications.length > 0 && (
                  <span className="notif-badge">{adminNotifications.length}</span>
                )}
              </button>
              {notifOpen && (
                <div className="notif-dropdown">
                  <div className="notif-dropdown-header">Notifications</div>
                  {adminNotifications.length === 0 ? (
                    <div className="notif-empty">No new notifications</div>
                  ) : (
                    adminNotifications.map(n => (
                      <div key={n.id} className="notif-item">
                        <span className="notif-msg">{n.message}</span>
                        <button className="notif-dismiss" onClick={() => dismissAdminNotif(n.id)}>✕</button>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
            <button className="dash-logout-sm" onClick={handleLogout}>{t.logout}</button>
          </div>
        </header>

        <div className="dash-content">

          {/* ── OVERVIEW ─────────────────────────────────────── */}

          {renderOverview(ctx)}
          {renderWorkers(ctx)}
          {renderProjects(ctx)}
          {renderSell(ctx)}
          {renderTraining(ctx)}
          {renderEquipment(ctx)}
          {renderItSupport(ctx)}
          {renderChat(ctx)}
          {renderTracking(ctx)}
          {renderVisitors(ctx)}
          {renderSchedule(ctx)}
          {renderPolicy(ctx)}
          {renderSafety(ctx)}
          {renderCareers(ctx)}
        </div>
      </div>
    </div>
  )
}

export default AdminDashboard
